<template>
  <div class="formate-box">
    <span class="formate-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.556"
        height="36.75"
        viewBox="0 0 27.556 36.75"
      >
        <path
          d="M26.545-5.22l-6.021-6.021a3.445,3.445,0,0,0-2.433-1.012H3.445A3.456,3.456,0,0,0,0-8.8V21.053A3.445,3.445,0,0,0,3.445,24.5H24.112a3.445,3.445,0,0,0,3.445-3.445V-2.78A3.461,3.461,0,0,0,26.545-5.22ZM24.923-3.591a1.129,1.129,0,0,1,.3.531H18.371V-9.913a1.129,1.129,0,0,1,.531.3ZM24.112,22.2H3.445A1.152,1.152,0,0,1,2.3,21.053V-8.8A1.152,1.152,0,0,1,3.445-9.949h12.63v7.463A1.718,1.718,0,0,0,17.8-.763H25.26V21.053A1.152,1.152,0,0,1,24.112,22.2ZM22.533,9.915c-.969-.954-3.947-.66-5.289-.481a7.511,7.511,0,0,1-3.236-4.062c.309-1.292.861-3.387.459-4.657a1.678,1.678,0,0,0-3.2-.488c-.359,1.313-.022,3.186.6,5.583a69.089,69.089,0,0,1-3.021,6.358c-1.493.768-3.882,2.1-4.22,3.76-.251,1.206,1.643,2.828,3.81.459a19.2,19.2,0,0,0,2.246-3.265A41.717,41.717,0,0,1,16.57,11.4a10.948,10.948,0,0,0,4.636,1.428A1.74,1.74,0,0,0,22.533,9.915ZM6.085,16.3a10.025,10.025,0,0,1,2.548-2.928C7.047,15.907,6.085,16.352,6.085,16.3ZM12.917.349c.624,0,.56,2.691.151,3.416C12.695,2.6,12.709.349,12.917.349ZM10.879,11.781a33.662,33.662,0,0,0,2.067-4.571,9.348,9.348,0,0,0,2.519,2.978A26.236,26.236,0,0,0,10.879,11.781Zm11.008-.423s-.416.5-3.122-.653C21.708,10.489,22.189,11.164,21.887,11.357Z"
          transform="translate(0 12.253)"
        />
      </svg>
    </span>
    <iframe
      :src="`http://docs.google.com/viewer?url=${url}&embedded=true`"
      style="border: none; padding:0;width:100%;height:100%;"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'docsViewer',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>
